import type { SVGProps } from 'react';
const SvgWarningFilled = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 16 16"
    height={16}
    fill="none"
    width={16}
    {...props}
  >
    <path d="M8 14A6 6 0 1 0 8 2a6 6 0 1 0 0 12" fill="currentColor" />
    <path d="M8 9V5M7.991 10.991l.018-1" stroke="#fff" />
  </svg>
);
export default SvgWarningFilled;
